import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
  },
  {
    key: "register-1",
    path: `${AUTH_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
  },
  {
    key: "register-2",
    path: `${AUTH_PREFIX_PATH}/register-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-2")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.analytic",
    path: `${APP_PREFIX_PATH}/dashboards/analytic`,
    component: React.lazy(() => import("views/app-views/dashboards/analytic")),
  },
  {
    key: "login-1",
    path: `${APP_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login-1")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "register-1",
    path: `${APP_PREFIX_PATH}/register-1`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-1")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "register-2",
    path: `${APP_PREFIX_PATH}/register-2`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-2")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "forgot-password",
    path: `${APP_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-1",
    path: `${APP_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "error-page-2",
    path: `${APP_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "pages",
    path: `${APP_PREFIX_PATH}/pages`,
    component: React.lazy(() => import("views/app-views/pages")),
  },
  {
    key: "Partner",
    path: `${APP_PREFIX_PATH}/partners/*`,
    component: React.lazy(() => import("views/new-views/partner")),
  },

  {
    key: "Partner",
    path: `${APP_PREFIX_PATH}/partners/list`,
    component: React.lazy(() => import("views/new-views/partner/partnerList")),
  },


  // {
  //   key: "models",
  //   path: `${APP_PREFIX_PATH}/models/list`,
  //   component: React.lazy(() => import("views/new-views/models/partnerList")),
  // },
  {
    key: "Partner",
    path: `${APP_PREFIX_PATH}/partners/add`,
    component: React.lazy(() => import("views/new-views/partner/partnerAdd")),
  },
  {
    key: "Partner",
    path: `${APP_PREFIX_PATH}/partners/edit/:id`,
    component: React.lazy(() => import("views/new-views/partner/partnerEdit")),
  },
{
    key: "Blog",
    path: `${APP_PREFIX_PATH}/blogs/*`,
    component: React.lazy(() => import("views/new-views/blog")),
  },

  {
    key: "Blog",
    path: `${APP_PREFIX_PATH}/blogs/list`,
    component: React.lazy(() => import("views/new-views/blog/blogList")),
  },

  {
    key: "Blog",
    path: `${APP_PREFIX_PATH}/blogs/add`,
    component: React.lazy(() => import("views/new-views/blog/blogAdd")),
  },

  {
    key: "Blog",
    path: `${APP_PREFIX_PATH}/blogs/edit/:id`,
    component: React.lazy(() => import("views/new-views/blog/blogEdit")),
  },
];
